import { Outlet } from "react-router-dom";

import { SidebarProvider } from "@ospra/design-system/components/sidebar";

import { AppSidebar } from "../components/appSidebar";

export function DashboardLayout() {
  return (
    <SidebarProvider>
      <div className="flex min-h-svh w-full bg-sidebar">
        <AppSidebar />
        <main className="relative mt-2 mr-2 mb-2 flex h-[calc(100svh-16px)] min-h-0 flex-1 flex-col overflow-hidden rounded-xl bg-background shadow-sm">
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
}
